import './data-attr-helper.js';

// Attache la variable globale si elle n’est pas déjà exposée
if (typeof window.dataAttrHelpers === 'undefined' && typeof dataAttrHelpers !== 'undefined') {
    window.dataAttrHelpers = dataAttrHelpers;
}